module.exports = __webpack_public_path__ + "static/media/DanskeNarrow-Italic.e3b116fe.svg";